import { findPremium, findPriceByPremium } from "@/common/pricing";
import {
  ANNUAL,
  DIRECTDEBIT,
  MONTHLY,
  MONTHLY_2_MONTHS_FREE,
  MONTHLY_3_MONTHS_DEFERRED,
} from "@/constants/common.constants.js";
import { LANDLORDS } from "@/constants/questionset.constants";

export default {
  methods: {
    buildPremiumBreakdownModel(
      quote,
      paymentMethod,
      paymentFrequency,
      productGroup,
      currentProductId = null
    ) {
      const premium = findPremium(
        quote?.Premiums,
        paymentMethod,
        paymentFrequency
      );
      const price = findPriceByPremium(quote?.Prices, premium);

      return {
        paymentFrequency,
        paymentMethod,
        price,
        premium,
        currentProductId,
      };
    },
    showPremiumBreakdownAnnual(quote, productGroup, currentProductId = null) {
      const breakdownModel = this.buildPremiumBreakdownModel(
        quote,
        DIRECTDEBIT,
        ANNUAL,
        productGroup === LANDLORDS,
        currentProductId
      );
      this.$refs.DialogContentPremiumBreakdown.open(
        "Premium breakdown",
        breakdownModel
      );
    },
    showPremiumBreakdownMonthly(
      quote,
      productGroup,
      title = "Premium breakdown"
    ) {
      const breakdownModel = this.buildPremiumBreakdownModel(
        quote,
        DIRECTDEBIT,
        MONTHLY,
        productGroup === LANDLORDS
      );
      this.$refs.DialogContentPremiumBreakdown.open(title, breakdownModel);
    },
    showPremiumBreakdown3Months(quote, productGroup) {
      const breakdownModel = this.buildPremiumBreakdownModel(
        quote,
        DIRECTDEBIT,
        MONTHLY_3_MONTHS_DEFERRED,
        productGroup === LANDLORDS
      );
      this.$refs.DialogContentPremiumBreakdown.open(
        "Premium breakdown",
        breakdownModel
      );
    },
    showPremiumBreakdown2MonthsFree(quote, productGroup) {
      const breakdownModel = this.buildPremiumBreakdownModel(
        quote,
        DIRECTDEBIT,
        MONTHLY_2_MONTHS_FREE,
        productGroup === LANDLORDS
      );
      this.$refs.DialogContentPremiumBreakdown.open(
        "Premium breakdown",
        breakdownModel
      );
    },
    showD2CPremiumBreakdown(quote, paymentMethod, paymentFrequency) {
      const breakdownModel = this.buildPremiumBreakdownModel(
        quote,
        paymentMethod,
        paymentFrequency
      );
      this.$refs.D2CDialogContentPremiumBreakdown.open(
        "Premium breakdown",
        breakdownModel
      );
    },
  },
};
